const formatPhoneNumber = (phoneNumber) =>
  phoneNumber
    ? `+${phoneNumber}`
    : null;

export default formatPhoneNumber;
